"use client";

import { parseAsBoolean, useQueryState } from "nuqs";

/**
 * Whether the mobile layout is showing the POI details view (`?poi=true`).
 *
 * Already a query param in the legacy app — the only piece of its URL state that
 * wasn't in the hash.
 */
export function usePOIView() {
  const [isPOIView, setPOIView] = useQueryState(
    "poi",
    parseAsBoolean.withDefault(false)
  );

  return { isPOIView, setPOIView };
}
